export const GET_AREAS_REQUEST = 'resources/areas/GET_AREAS_REQUEST'
export const GET_AREAS_SUCCESS = 'resources/areas/GET_AREAS_SUCCESS'
export const GET_AREAS_ERROR = 'resources/areas/GET_AREAS_ERROR'

export const FETCH_AREA_REQUEST = 'resources/areas/FETCH_AREA_REQUEST'
export const FETCH_AREA_SUCCESS = 'resources/areas/FETCH_AREA_SUCCESS'
export const FETCH_AREA_FAILURE = 'resources/areas/FETCH_AREA_FAILURE'
